<template>
	<section class="app-container">
		<div class="container">
			<div v-if="!current_user" class="alert">
				<div class="alert__body">
					<span>Please login to view your profile.</span>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import global_data from '../../main';
export default {
	name: 'MyProfile',
	metaInfo: {
      title: 'My Profile',
    },
	data: function(){
		return {
			current_user: null,
		};
	},
	mounted(){
		var self = this;
		this.GetAPIUser(function(user){
			if (user) {
				self.current_user = user;
				self.goToUser(user);
			}
			else{
				global_data.$on("user_changed", function(new_user){
					self.goToUser(new_user);
				});
			}
		});
	},
	methods:{
		goToUser:function(user){
			if (user) {
				this.$router.push({ name: 'profile', params: { id: user.id }}) 
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/MyProfile.vue